export const getAssetsUrl = () => {
  return `https://${process.env.NEXT_PUBLIC_ASSETS_OUTPUT}/`;
};

export const getOutputBucketUrl = () => {
  return `${process.env.NEXT_PUBLIC_TOLSTOY_VIDEO_BASE_URL}`;
};

export const getTolstoyPublicVideoBaseUrl = ({ baseFolder }: { baseFolder: string }) => {
  return `${process.env.NEXT_PUBLIC_TOLSTOY_VIDEO_BASE_URL}/public/${baseFolder}`;
};
